export const intialState={
    isOtpMatched:false,
    otp:Number
}